"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPharmacyProductComparisonValue = exports.unitComparisonMap = exports.getProductComparisonValue = void 0;
const getDepositString = (deposit, discountBatchSize) => {
    const totalDeposit = discountBatchSize ? deposit * discountBatchSize : deposit;
    return `Hinta sis. pantin ${(totalDeposit / 100).toFixed(2).replace('.', ',')} €`;
};
const getComparisonPriceAndDepositString = ({ comparisonUnit, packageSize, price, deposit, discountBatchSize }) => {
    let comparisonPrice;
    if (discountBatchSize) {
        const totalSize = packageSize * discountBatchSize;
        comparisonPrice = price / totalSize;
    }
    else {
        comparisonPrice = price / packageSize;
    }
    const comparisonPriceString = (comparisonPrice / 100).toFixed(2).replace('.', ',');
    const depositString = deposit ? getDepositString(deposit, discountBatchSize) : undefined;
    const result = depositString
        ? `${comparisonPriceString} € / ${comparisonUnit}. ${depositString}`
        : `${comparisonPriceString} € / ${comparisonUnit}`;
    return result;
};
/**
 * Get comparison string value with deposit for Retail product based on
 * price, package size, package unit, comparison unit, deposit and discount batch size.
 * Returns undefined if packageUnit, packageSize, price or comparisonUnit is missing.
 */
const getProductComparisonValue = (item) => {
    const { discountPrice, discountBatchSize, price, packageSize, packageUnit, comparisonUnit, deposit } = item;
    let currentPrice = discountPrice || price;
    if (currentPrice) {
        const depositTotal = deposit
            ? discountBatchSize
                ? discountBatchSize * deposit
                : deposit
            : undefined;
        currentPrice = depositTotal ? currentPrice - depositTotal : currentPrice;
    }
    const size = typeof packageSize === 'number' ? packageSize : parseFloat(packageSize || ''); // packageSize might be string
    if (!packageUnit || !size || !currentPrice || !comparisonUnit) {
        return undefined;
    }
    else if (packageUnit === comparisonUnit) {
        const comparisonPrice = getComparisonPriceAndDepositString({
            comparisonUnit,
            packageSize: size,
            price: currentPrice,
            deposit,
            discountBatchSize
        });
        return comparisonPrice;
    }
    else {
        const packageSizeAsComparisonUnitSize = unitComparisonMap(size)[packageUnit][comparisonUnit];
        const comparisonPrice = getComparisonPriceAndDepositString({
            comparisonUnit,
            packageSize: packageSizeAsComparisonUnitSize,
            price: currentPrice,
            deposit,
            discountBatchSize
        });
        return comparisonPrice;
    }
};
exports.getProductComparisonValue = getProductComparisonValue;
/**
 * Get comparison unit for given `packageUnit`
 * @example const packageUnit = 'ml'
 *  getComparisonUnit(packageUnit)
 * // => 'l' since litres are used for the comparison unit
 * @returns unit used for comparison
 */
const getComparisonUnit = (packageUnit) => {
    switch (packageUnit) {
        case 'ml':
        case 'l':
            return 'l';
        case 'mg':
        case 'g':
        case 'kg':
            return 'kg';
        default:
            return packageUnit;
    }
};
/**
 * Get comparison string value for PharmacyProduct
 */
const getPharmacyProductComparisonValue = ({ price, packageUnit, packageSize, packageMultiplier, delimiter = ',' }) => {
    if (price && packageUnit && packageSize) {
        // packageUnit might contain whitespace at end?
        const trimmedPackageUnit = packageUnit.trim();
        const totalSize = packageMultiplier ? packageSize * packageMultiplier : packageSize;
        const comparisonUnit = getComparisonUnit(trimmedPackageUnit);
        const packageSizeAsComparisonUnitSize = trimmedPackageUnit === comparisonUnit
            ? totalSize
            : unitComparisonMap(totalSize)[trimmedPackageUnit][comparisonUnit];
        const comparisonPrice = price / packageSizeAsComparisonUnitSize;
        const comparisonPriceString = (comparisonPrice / 100).toFixed(2).replace('.', delimiter);
        return `${comparisonPriceString} € / ${comparisonUnit}`;
    }
    return undefined;
};
exports.getPharmacyProductComparisonValue = getPharmacyProductComparisonValue;
/**
 * Map of converted unit values.
 * Usage example:
 * @example
 * const packageSize = 500
 * const packageUnit = ml
 * const comparisonUnit = l
 * unitComparisonMap(500)[packageUnit][comparisonUnit]
 * // => 0.5
 * @param amount
 */
const unitComparisonMap = (amount) => ({
    ml: {
        cl: amount / 10,
        dl: amount / 100,
        l: amount / 1000
    },
    cl: {
        ml: amount * 10,
        dl: amount / 10,
        l: amount / 100
    },
    dl: {
        ml: amount * 100,
        cl: amount * 10,
        l: amount / 10
    },
    l: {
        ml: amount * 1000,
        cl: amount * 100,
        dl: amount * 10
    },
    g: {
        kg: amount / 1000
    },
    kg: {
        g: amount * 1000
    }
});
exports.unitComparisonMap = unitComparisonMap;
//# sourceMappingURL=productComparison.js.map